import { Component } from '@angular/core';
import {MapService} from '../../../commons/map.service';

@Component({
  selector: 'app-screenshot',
  templateUrl: './screenshot.component.html'
})
export class ScreenshotComponent {

  takingScreenShot: boolean = false;
  protected prepareScreenshotFunction: any;
  protected takeScreenshotFunction: any;
  protected timeout = 10000; // in ms
  protected canvasUrl: any;

  constructor(private mapService: MapService) { }

  takeScreenShotForVolume() {
    // configure settings

    this.takingScreenShot = true;


// define callback functions
    this.prepareScreenshotFunction = this.prepareScreenshot.bind(this)

    this.mapService.viewer.scene.preRender.addEventListener(this.prepareScreenshotFunction);

  }

  prepareScreenshot() {
    var canvas = this.mapService.viewer.scene.canvas;
    this.mapService.viewer.scene.preRender.removeEventListener(this.prepareScreenshotFunction);
    // take snapshot after defined timeout to allow scene update (ie. loading data)
    setTimeout(() => {
      this.takeScreenshotFunction = this.takeScreenshot.bind(this)
      this.mapService.viewer.scene.postRender.addEventListener(this.takeScreenshotFunction);
    }, this.timeout);
  }

  takeScreenshot() {
    this.mapService.viewer.scene.postRender.removeEventListener(this.takeScreenshotFunction);
    var canvas = this.mapService.viewer.scene.canvas;
    canvas.toBlob((blob) => {
      let downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.setAttribute('download', 'Screenshot ' + new Date() + '.png');
      document.body.appendChild(downloadLink);
      downloadLink.click();
      this.takingScreenShot = false;
    });
  }
}
